/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StockAdjustmentReason {
  Damage = 'DAMAGE',
  Expiration = 'EXPIRATION',
  Consumption = 'CONSUMPTION',
  Theft = 'THEFT',
  Correction = 'CORRECTION',
  Inventory = 'INVENTORY',
  Other = 'OTHER'
}
